import React, { useLayoutEffect, useEffect } from 'react';
import HeaderV3 from '../../../components/HeaderV3/headerV3.component';
import FooterSection from '../../../components/FooterSection/footersection.component';
import OrbixContact from '../../../components/ContactSection/contact.component';
import HexCoreSection from './prime-components/HexCoreSection/HexCoreSection';
import FirewallSection from './prime-components/FirewallSection/FirewallSection';
import AdrSection from './prime-components/AdrSection/AdrSection';
import VideoSection from './prime-components/VideoSection/VideoSection';
import ProveSection from './prime-components/ProveSection/ProveSection';
import AnalyticsSection from './prime-components/AnalyticsSection/AnalyticsSection';
import FaqSection from './prime-components/FaqSection/FaqSection';
import './prime.component.css';

function PrimePage() {
  useLayoutEffect(() => {
    document.body.style.backgroundColor = '#130F22';
    return () => { document.body.style.backgroundColor = ''; };
  }, []);

  useEffect(() => {
    const reveals = document.querySelectorAll('#prime-page .pm-reveal');
    const obs = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('pm-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    reveals.forEach(el => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <div id="prime-page">
      <HeaderV3 />
      <main>
        <HexCoreSection />
        <AdrSection />
        <FirewallSection />
        <VideoSection />
        <ProveSection />
        <AnalyticsSection />
        <FaqSection />
        <div id="prime-contact" className="page-wrapper dark-mode">
          <OrbixContact
            subheading="Contact us today."
            heading="Reach out to our team to book a demo or learn more."
          />
        </div>
      </main>
      <FooterSection />
    </div>
  );
}

export default PrimePage;
